import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Table,
  Button,
  Modal,
  Input,
  Form,
  Upload,
  Tooltip,
  Space,
  Select,
  message,
} from "antd";
import {
  InfoCircleOutlined,
  DeleteOutlined,
  EditOutlined,
  PlusOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function Resources() {
  const token = localStorage.getItem("token");
  const role = (localStorage.getItem("role") || "").toUpperCase();

  const [tools, setTools] = useState([]);
  const [loading, setLoading] = useState(false);

  const [createModalOpen, setCreateModalOpen] = useState(false);
  const [updateModalOpen, setUpdateModalOpen] = useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);

  const [selectedTool, setSelectedTool] = useState(null);
  const [deleteText, setDeleteText] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const [toolFile, setToolFile] = useState(null);
  const [toolImage, setToolImage] = useState(null);
  const [updateToolFile, setUpdateToolFile] = useState(null);
  const [updateToolImage, setUpdateToolImage] = useState(null);


const [updateToolFileList, setUpdateToolFileList] = useState([]);
const [updateToolImageList, setUpdateToolImageList] = useState([]);

  const [activeCategory, setActiveCategory] = useState("ALL");

  const [toolFileList, setToolFileList] = useState([]);
const [toolImageList, setToolImageList] = useState([]);

  const [createForm] = Form.useForm();
  const [updateForm] = Form.useForm();

  const isAdmin = role === "ADMIN";

  useEffect(() => {
    fetchTools();
  }, []);

  const categoryTabs = [
  "ALL",
  "NETWORK",
  "WEB",
  "ANDROID",
  "API",
  "THICK CLIENT",
  "OTHERS",
 
];

const filteredTools =
  activeCategory === "ALL"
    ? tools
    : tools.filter((item) => item.ToolCategory === activeCategory);

  const fetchTools = async () => {
    try {
      setLoading(true);

      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/resources/all-tools`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (res.data.success) {
        setTools(res.data.data || []);
      }
    } catch (err) {
      toast.error("Failed to load resources");
    } finally {
      setLoading(false);
    }
  };

  const handleCreate = async (values) => {
    try {
      setSubmitting(true);

      const formData = new FormData();
      formData.append("ToolName", values.ToolName);
      formData.append("ToolDescription", values.ToolDescription || "");
      formData.append("ToolUrl", values.ToolUrl || "");
      formData.append("ToolCategory", values.ToolCategory || "");

      if (toolFile) formData.append("ToolFile", toolFile);
      if (toolImage) formData.append("ToolImage", toolImage);

      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/resources/create-tool`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

    if (res.data.success) {
  toast.success("Resource created successfully");
  closeCreateModal();
  fetchTools();
}
    } catch (err) {
      toast.error(err?.response?.data?.message || "Create failed");
    } finally {
      setSubmitting(false);
    }
  };

  const openUpdateModal = (tool) => {
    setSelectedTool(tool);
    updateForm.setFieldsValue({
      ToolName: tool.ToolName,
      ToolDescription: tool.ToolDescription,
      ToolUrl: tool.ToolUrl?.startsWith("resources/") ? "" : tool.ToolUrl,
      IsActive: tool.IsActive,
      ToolCategory: tool.ToolCategory
    });
    setUpdateToolFile(null);
    setUpdateToolImage(null);
    setUpdateModalOpen(true);
  };

  const handleUpdate = async (values) => {
    try {
      if (!selectedTool) return;

      setSubmitting(true);

      const formData = new FormData();

      if (values.ToolName !== undefined) formData.append("ToolName", values.ToolName);
      if (values.ToolDescription !== undefined) formData.append("ToolDescription", values.ToolDescription);
      if (values.ToolUrl !== undefined) formData.append("ToolUrl", values.ToolUrl);
      if (values.IsActive !== undefined) formData.append("IsActive", values.IsActive);
      if (values.ToolCategory !== undefined) formData.append("ToolCategory", values.ToolCategory);

      if (updateToolFile) formData.append("ToolFile", updateToolFile);
      if (updateToolImage) formData.append("ToolImage", updateToolImage);

      const res = await axios.put(
        `${process.env.REACT_APP_API_URL}/resources/update-tool/${selectedTool.id}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (res.data.success) {
  toast.success("Resource updated successfully");
  closeUpdateModal();
  fetchTools();
}
    } catch (err) {
      toast.error(err?.response?.data?.message || "Update failed");
    } finally {
      setSubmitting(false);
    }
  };

  const handleDelete = async () => {
    try {
      if (!selectedTool) return;

      setSubmitting(true);

      const res = await axios.delete(
        `${process.env.REACT_APP_API_URL}/resources/delete-tool/${selectedTool.id}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (res.data.success) {
        toast.success("Resource deleted successfully");
        setDeleteModalOpen(false);
        setSelectedTool(null);
        setDeleteText("");
        fetchTools();
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || "Delete failed");
    } finally {
      setSubmitting(false);
    }
  };

  const closeCreateModal = () => {
  setCreateModalOpen(false);
  createForm.resetFields();
  setToolFile(null);
  setToolImage(null);
  setToolFileList([]);
  setToolImageList([]);
};

const closeUpdateModal = () => {
  setUpdateModalOpen(false);
  updateForm.resetFields();
  setUpdateToolFile(null);
  setUpdateToolImage(null);
  setUpdateToolFileList([]);
  setUpdateToolImageList([]);
  setSelectedTool(null);
};
  const openDeleteModal = (tool) => {
    setSelectedTool(tool);
    setDeleteText("");
    setDeleteModalOpen(true);
  };

 const handleDownload = (tool) => {
  try {
    const url = tool?.ToolSignedUrl || tool?.ToolUrl;

    if (!url) {
      toast.error("No resource available");
      return;
    }

    const fileType = (tool?.FileType || "").toLowerCase().trim();
    const safeToolName = (tool?.ToolName || "resource")
      .replace(/[^a-zA-Z0-9-_]/g, "_")
      .toLowerCase();

    const fileName =
      tool?.FileName ||
      `${safeToolName}${fileType ? `.${fileType}` : ""}`;

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", fileName);
    link.setAttribute("target", "_blank");
    link.setAttribute("rel", "noopener noreferrer");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (err) {
    console.error("Download error:", err);
    toast.error("Failed to download resource");
  }
};

  const columns = [
    {
      title: <span className="text-black text-md">S.No</span>,
      key: "serial",
      render: (_, __, index) => index + 1,
      width: 80,
    },
    {
      title: <span className="text-black text-md">Logo</span>,
      dataIndex: "ToolImageSignedUrl",
      key: "ToolImageSignedUrl",
      render: (value, record) =>
        value ? (
          <img
            src={value}
            alt={record.ToolName}
            className="object-cover w-12 h-12 border rounded-lg"
          />
        ) : (
          <div className="flex items-center justify-center w-12 h-12 text-xs text-gray-400 border rounded-lg">
            N/A
          </div>
        ),
      width: 120,
    },
    {
      title: <span className="text-black text-md">Tool Name</span>,
      dataIndex: "ToolName",
      key: "ToolName",
      render: (value) => (
        <span className="font-semibold text-slate-800">{value}</span>
      ),
    },
    {
      title: <span className="text-black text-md">Download</span>,
      key: "download",
      render: (_, record) => (
        <Space>
          <Button type="primary" onClick={() => handleDownload(record)}>
            Download
          </Button>

          <Tooltip title={record.ToolDescription || "No description"}>
            <InfoCircleOutlined className="text-lg text-blue-600 cursor-pointer" />
          </Tooltip>
        </Space>
      ),
    },
    ...(isAdmin
      ? [
          {
            title: <span className="text-black text-md">Actions</span>,
            key: "actions",
            render: (_, record) => (
              <Space>
                <Button
                  icon={<EditOutlined />}
                  onClick={() => openUpdateModal(record)}
                  className="text-white bg-slate-700 hover:text-black"
                >
                  Update
                </Button>

                <Button
                  danger
                  icon={<DeleteOutlined />}
                  onClick={() => openDeleteModal(record)}
                >
                  Delete
                </Button>
              </Space>
            ),
          },
        ]
      : []),
  ];

  return (
    <div className="p-6 bg-slate-300">
       <ToastContainer
                                          position="bottom-left"
                                          autoClose={5000}
                                          hideProgressBar={true}
                                          newestOnTop={false}
                                          closeOnClick
                                          rtl={false}
                                          pauseOnFocusLoss
                                          draggable
                                          pauseOnHover
                                          theme="dark"
                                          className="!mb-6 !ml-4"
                                          toastClassName="!inline-flex !items-center !whitespace-nowrap !bg-black !text-white !px-4 !py-2 !rounded-lg !w-auto !min-w-0 !shadow-lg"
                                        />

      <div className="relative mb-8 overflow-hidden border shadow-xl bg-gradient-to-br from-slate-950 via-slate-900 to-blue-950 rounded-3xl border-white/10">

  {/* BACKGROUND GLOW */}
  <div className="absolute inset-0 pointer-events-none">
    <div className="absolute top-0 left-0 rounded-full w-72 h-72 bg-cyan-500/10 blur-3xl" />
    <div className="absolute bottom-0 right-0 rounded-full w-80 h-80 bg-blue-500/10 blur-3xl" />
    <div className="absolute w-40 h-40 border rounded-full top-10 right-24 border-white/5" />
    <div className="absolute w-56 h-56 border rounded-full -bottom-10 left-16 border-cyan-400/10" />
  </div>

  <div className="relative z-10 p-8 md:p-10">

    {/* TOP BAR */}
    <div className="flex flex-col gap-6 md:flex-row md:items-start md:justify-between">

      {/* LEFT CONTENT */}
      <div className="max-w-5xl">
        <div className="inline-flex items-center gap-2 px-4 py-1 mb-4 text-xs font-semibold tracking-[0.25em] uppercase border rounded-full bg-white/5 text-cyan-300 border-cyan-400/20">
          Cyber Security Resource Hub
        </div>

        <h1 className="text-xl font-extrabold leading-tight tracking-tight text-white md:text-2xl">
          
          <span className="block text-transparent bg-gradient-to-r from-cyan-300 via-blue-400 to-indigo-400 bg-clip-text">
           Resources for Practical Cyber Security Training
          </span>
        </h1>

        <div className="max-w-3xl mt-2">

  <p className="text-sm leading-7 md:text-base text-slate-300">
    The <span className="font-semibold text-cyan-300">Resource Section</span> provides access to all essential tools and materials in one centralized location - No more searching across chats and pdf or tracking scattered download links.
  </p>

  <div className="mt-2 space-y-1">
    <p className="text-xs font-semibold tracking-[0.25em] uppercase text-slate-400">
      What you’ll find
    </p>

    <div className="text-sm text-slate-300">

      <div className="flex items-start gap-3">
        <span className="mt-1 text-cyan-400">▹</span>
        <p>
          Curated links to official tool repositories and trusted sources
        </p>
      </div>

      <div className="flex items-start gap-3">
        <span className="mt-1 text-blue-400">▹</span>
        <p>
          Direct access to essential cybersecurity tools used in real-world scenarios
        </p>
      </div>

      <div className="flex items-start gap-3">
        <span className="mt-1 text-indigo-400">▹</span>
        <p>
          Downloadable resources such as CV templates, sample reports, checklists, and supporting materials
        </p>
      </div>

    </div>
  </div>

</div>

        
      </div>

      {/* RIGHT ACTION */}
      <div className="flex flex-col items-start gap-4 md:items-end">
        {isAdmin && (
          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={() => setCreateModalOpen(true)}
            className="!h-11 !px-6 !rounded-xl !border-0 !font-semibold !shadow-lg"
          >
            Add Resource
          </Button>
        )}

        <div className="grid w-full grid-cols-2 gap-3 md:w-72">
          <div className="p-4 border bg-white/5 rounded-2xl border-white/10 backdrop-blur-sm">
            <p className="text-[11px] font-semibold tracking-widest uppercase text-slate-400">
              Purpose
            </p>
            <p className="mt-2 text-sm font-semibold text-white">
              Learn by using real tools
            </p>
          </div>

          <div className="p-4 border bg-white/5 rounded-2xl border-white/10 backdrop-blur-sm">
            <p className="text-[11px] font-semibold tracking-widest uppercase text-slate-400">
              Focus
            </p>
            <p className="mt-2 text-sm font-semibold text-white">
              Practice-driven security
            </p>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>

      <div className="relative overflow-hidden border shadow-xl bg-gradient-to-br from-slate-950 via-slate-900 to-blue-950 rounded-3xl border-white/10">

  {/* BACKGROUND GLOW */}
  <div className="absolute inset-0 pointer-events-none">
    <div className="absolute top-0 left-0 rounded-full w-72 h-72 bg-cyan-500/10 blur-3xl" />
    <div className="absolute bottom-0 right-0 rounded-full w-80 h-80 bg-blue-500/10 blur-3xl" />
  </div>

  <div className="relative z-10 p-6">

    {/* HEADER */}
    <div className="flex items-center justify-between mb-6">
      <div>
        <h2 className="text-xl font-bold text-white">
          Available Resources
        </h2>
        <p className="text-sm text-slate-400">
          Browse and access cybersecurity tools and downloads
        </p>
      </div>

      <div className="px-3 py-1.5 text-xs font-semibold border rounded-full text-cyan-300 bg-cyan-400/10 border-cyan-400/20">
        {filteredTools.length} Tools
      </div>
    </div>

    {/* SHIFTING CATEGORY TABS */}
    
      <div className="flex flex-wrap justify-center gap-4 mb-6">

  {categoryTabs.map((tab) => {
    const isActive = activeCategory === tab;

    return (
      <div key={tab} className="relative">

        <button
          onClick={() => setActiveCategory(tab)}
          className={`
            px-6 py-3 rounded-2xl text-sm font-semibold tracking-wide
            transition-all duration-300 border
            flex items-center gap-2

            ${
              isActive
                ? "bg-gradient-to-r from-cyan-500 to-blue-600 text-white border-cyan-400/40 shadow-lg shadow-cyan-900/40 scale-[1.05]"
                : "bg-white/5 text-slate-300 border-white/10 hover:bg-white/10 hover:text-white hover:scale-[1.03]"
            }
          `}
        >

          {/* OPTIONAL ICON */}
          <span className="text-xs opacity-80">
            {tab === "WEB" && "🌐"}
            {tab === "API" && "🔗"}
            {tab === "ANDROID" && "📱"}
            {tab === "NETWORK" && "🛰"}
            {tab === "ALL" && "✨"}
            {tab === "THICK CLIENT" && "🖥️"}
            {tab === "OTHERS" && "⚙️"}
          </span>

          {/* LABEL */}
          <span>
            {tab === "REVERSE_ENGINEERING"
              ? "REVERSE"
              : tab.replaceAll("_", " ")}
          </span>

        </button>

      </div>
    );
  })}

</div>

    {/* TABLE */}
    <div className="overflow-hidden border rounded-2xl border-white/10 bg-white/5 backdrop-blur-md">
      <Table
        rowKey="id"
        loading={loading}
        columns={columns}
        dataSource={filteredTools}
        pagination={{
          pageSize: 20,
          className: "!px-6 !py-4",
        }}
        className="pro-table"
      />
    </div>

  </div>
</div>

      {/* CREATE MODAL */}
<Modal
  open={createModalOpen}
  onCancel={closeCreateModal}
  footer={null}
  width={820}
  centered
  closable={false}
>
  <div className="overflow-hidden border shadow-2xl rounded-3xl border-slate-200">
    {/* HEADER */}
    <div className="px-8 py-6 border-b bg-gradient-to-r from-slate-950 via-slate-900 to-blue-950 border-white/10">
      <div className="flex items-start justify-between gap-4">
        <div>
          <p className="text-xs font-semibold tracking-[0.25em] uppercase text-cyan-300">
            Resource Management
          </p>
          <h2 className="mt-2 text-2xl font-bold text-white">
            Create New Resource
          </h2>
          <p className="mt-2 text-sm text-slate-300">
            Add a new cybersecurity tool, downloadable resource, or external reference link for learners.
          </p>
        </div>

        <button
          onClick={closeCreateModal}
          className="flex items-center justify-center w-10 h-10 text-white transition rounded-xl bg-white/10 hover:bg-white/20"
        >
          ✕
        </button>
      </div>
    </div>

    {/* BODY */}
    <div className="px-8 py-8 bg-white">
      <Form layout="vertical" form={createForm} onFinish={handleCreate}>
        {/* BASIC DETAILS */}
        <div className="grid grid-cols-1 gap-5 md:grid-cols-2">
          <Form.Item
            label={<span className="font-semibold text-slate-700">Tool Name</span>}
            name="ToolName"
            rules={[{ required: true, message: "Tool name is required" }]}
          >
            <Input
              placeholder="Enter tool name"
              className="h-11 rounded-xl"
            />
          </Form.Item>

          <Form.Item
            name="ToolCategory"
            label={<span className="font-semibold text-slate-700">Tool Category</span>}
            rules={[{ required: true, message: "Select category" }]}
          >
            <Select
              placeholder="Select category"
              className="resource-select"
              size="large"
            >
              <Select.Option value="NETWORK">NETWORK</Select.Option>
              <Select.Option value="WEB">WEB</Select.Option>
              <Select.Option value="ANDROID">ANDROID</Select.Option>
              <Select.Option value="API">API</Select.Option>
              <Select.Option value="THICK CLIENT">THICK CLIENT</Select.Option>
              <Select.Option value="OTHERS">OTHERS</Select.Option>
            </Select>
          </Form.Item>
        </div>

        <Form.Item
          label={<span className="font-semibold text-slate-700">Tool Description</span>}
          name="ToolDescription"
        >
          <Input.TextArea
            rows={5}
            placeholder="Write a clear description about the tool, its usage, and how it supports cybersecurity training."
            className="rounded-2xl"
          />
        </Form.Item>

        <Form.Item
          label={<span className="font-semibold text-slate-700">Tool URL</span>}
          name="ToolUrl"
        >
          <Input
            placeholder="https://example.com/tool  (optional if uploading file)"
            className="h-11 rounded-xl"
          />
        </Form.Item>

        {/* UPLOAD SECTION */}
        <div className="grid grid-cols-1 gap-5 mt-2 md:grid-cols-2">
          <div className="p-5 border border-dashed rounded-2xl bg-slate-50 border-slate-300">
            <p className="text-sm font-semibold text-slate-800">Upload Tool File</p>
            <p className="mt-1 text-xs text-slate-500">
              Upload PDF, ZIP, HTML, JSON, DOC, or other supported files.
            </p>

            <div className="mt-4">
              <Upload
                fileList={toolFileList}
                beforeUpload={(file) => {
                  setToolFile(file);
                  setToolFileList([file]);
                  return false;
                }}
                onRemove={() => {
                  setToolFile(null);
                  setToolFileList([]);
                }}
                maxCount={1}
              >
                <Button
                  icon={<UploadOutlined />}
                  className="font-medium rounded-xl h-11"
                >
                  Select Tool File
                </Button>
              </Upload>
            </div>
          </div>

          <div className="p-5 border border-dashed rounded-2xl bg-slate-50 border-slate-300">
            <p className="text-sm font-semibold text-slate-800">Upload Tool Image</p>
            <p className="mt-1 text-xs text-slate-500">
              Add a logo or preview image to visually represent the resource.
            </p>

            <div className="mt-4">
              <Upload
                fileList={toolImageList}
                beforeUpload={(file) => {
                  setToolImage(file);
                  setToolImageList([file]);
                  return false;
                }}
                onRemove={() => {
                  setToolImage(null);
                  setToolImageList([]);
                }}
                maxCount={1}
              >
                <Button
                  icon={<UploadOutlined />}
                  className="font-medium rounded-xl h-11"
                >
                  Select Tool Image
                </Button>
              </Upload>
            </div>
          </div>
        </div>

        {/* FOOTER */}
        <div className="flex justify-end gap-3 pt-8 mt-8 border-t border-slate-200">
          <Button
            onClick={closeCreateModal}
            className="font-medium rounded-xl h-11 px-7"
          >
            Cancel
          </Button>

          <Button
            htmlType="submit"
            type="primary"
            loading={submitting}
            className="font-semibold rounded-xl h-11 px-7"
          >
            Create Resource
          </Button>
        </div>
      </Form>
    </div>
  </div>
</Modal>


{/* UPDATE MODAL */}
<Modal
  open={updateModalOpen}
  onCancel={closeUpdateModal}
  footer={null}
  width={820}
  centered
  closable={false}
>
  <div className="overflow-hidden border shadow-2xl rounded-3xl border-slate-200">
    {/* HEADER */}
    <div className="px-8 py-6 border-b bg-gradient-to-r from-amber-500 via-orange-500 to-rose-500 border-white/10">
      <div className="flex items-start justify-between gap-4">
        <div>
          <p className="text-xs font-semibold tracking-[0.25em] uppercase text-white/80">
            Resource Management
          </p>
          <h2 className="mt-2 text-2xl font-bold text-white">
            Update Resource
          </h2>
          <p className="mt-2 text-sm text-white/85">
            Modify the resource details, replace files, or update its category and access status.
          </p>
        </div>

        <button
          onClick={closeUpdateModal}
          className="flex items-center justify-center w-10 h-10 text-white transition rounded-xl bg-white/15 hover:bg-white/25"
        >
          ✕
        </button>
      </div>
    </div>

    {/* BODY */}
    <div className="px-8 py-8 bg-white">
      <Form layout="vertical" form={updateForm} onFinish={handleUpdate}>
        {/* BASIC DETAILS */}
        <div className="grid grid-cols-1 gap-5 md:grid-cols-2">
          <Form.Item
            label={<span className="font-semibold text-slate-700">Tool Name</span>}
            name="ToolName"
            rules={[{ required: true, message: "Tool name is required" }]}
          >
            <Input
              placeholder="Enter tool name"
              className="h-11 rounded-xl"
            />
          </Form.Item>

          <Form.Item
            name="ToolCategory"
            label={<span className="font-semibold text-slate-700">Tool Category</span>}
            rules={[{ required: true, message: "Select category" }]}
          >
            <Select
              placeholder="Select category"
              className="resource-select"
              size="large"
            >
              <Select.Option value="NETWORK">NETWORK</Select.Option>
              <Select.Option value="WEB">WEB</Select.Option>
              <Select.Option value="ANDROID">ANDROID</Select.Option>
              <Select.Option value="API">API</Select.Option>
              <Select.Option value="THICK CLIENT">THICK CLIENT</Select.Option>
              <Select.Option value="OTHERS">OTHERS</Select.Option>
            </Select>
          </Form.Item>
        </div>

        <Form.Item
          label={<span className="font-semibold text-slate-700">Tool Description</span>}
          name="ToolDescription"
        >
          <Input.TextArea
            rows={6}
            placeholder="Update description, learning context, or usage instructions."
            className="rounded-2xl"
          />
        </Form.Item>

        <div className="grid grid-cols-1 gap-5 md:grid-cols-2">
          <Form.Item
            label={<span className="font-semibold text-slate-700">Tool URL</span>}
            name="ToolUrl"
          >
            <Input
              placeholder="https://example.com/tool"
              className="h-11 rounded-xl"
            />
          </Form.Item>

          <Form.Item
            label={<span className="font-semibold text-slate-700">Status</span>}
            name="IsActive"
          >
            <Select
              placeholder="Select status"
              className="resource-select"
              size="large"
            >
              <Select.Option value={true}>ACTIVE</Select.Option>
              <Select.Option value={false}>INACTIVE</Select.Option>
            </Select>
          </Form.Item>
        </div>

        {/* REPLACE FILES */}
        <div className="grid grid-cols-1 gap-5 mt-2 md:grid-cols-2">
          <div className="p-5 border border-dashed rounded-2xl bg-amber-50 border-amber-200">
            <p className="text-sm font-semibold text-slate-800">Replace Tool File</p>
            <p className="mt-1 text-xs text-slate-500">
              Upload a new file to replace the current downloadable resource.
            </p>

            <div className="mt-4">
              <Upload
                fileList={updateToolFileList}
                beforeUpload={(file) => {
                  setUpdateToolFile(file);
                  setUpdateToolFileList([file]);
                  return false;
                }}
                onRemove={() => {
                  setUpdateToolFile(null);
                  setUpdateToolFileList([]);
                }}
                maxCount={1}
              >
                <Button
                  icon={<UploadOutlined />}
                  className="font-medium rounded-xl h-11"
                >
                  Upload New File
                </Button>
              </Upload>
            </div>
          </div>

          <div className="p-5 border border-dashed rounded-2xl bg-amber-50 border-amber-200">
            <p className="text-sm font-semibold text-slate-800">Replace Tool Image</p>
            <p className="mt-1 text-xs text-slate-500">
              Upload a new image to replace the current tool logo or preview.
            </p>

            <div className="mt-4">
              <Upload
                fileList={updateToolImageList}
                beforeUpload={(file) => {
                  setUpdateToolImage(file);
                  setUpdateToolImageList([file]);
                  return false;
                }}
                onRemove={() => {
                  setUpdateToolImage(null);
                  setUpdateToolImageList([]);
                }}
                maxCount={1}
              >
                <Button
                  icon={<UploadOutlined />}
                  className="font-medium rounded-xl h-11"
                >
                  Upload New Image
                </Button>
              </Upload>
            </div>
          </div>
        </div>

        {/* FOOTER */}
        <div className="flex justify-end gap-3 pt-8 mt-8 border-t border-slate-200">
          <Button
            onClick={closeUpdateModal}
            className="font-medium rounded-xl h-11 px-7"
          >
            Cancel
          </Button>

          <Button
            htmlType="submit"
            type="primary"
            loading={submitting}
            className="font-semibold rounded-xl h-11 px-7"
          >
            Update Resource
          </Button>
        </div>
      </Form>
    </div>
  </div>
</Modal>

      {/* DELETE MODAL */}
      <Modal
        open={deleteModalOpen}
        onCancel={() => {
          setDeleteModalOpen(false);
          setDeleteText("");
          setSelectedTool(null);
        }}
        footer={null}
        title="Delete Resource"
      >
        {selectedTool && (
          <div className="space-y-4">
            <div className="p-4 border border-red-200 rounded-xl bg-red-50">
              <p className="text-sm text-gray-600">Tool Name</p>
              <h2 className="text-lg font-bold text-slate-800">
                {selectedTool.ToolName}
              </h2>
            </div>

            <div>
              <label className="block mb-2 text-sm font-semibold text-gray-700">
                Type exact tool name to enable delete
              </label>
              <Input
                value={deleteText}
                onChange={(e) => setDeleteText(e.target.value)}
                placeholder="Enter exact Tool Name"
              />
            </div>

            <div className="flex justify-end gap-2">
              <Button
                onClick={() => {
                  setDeleteModalOpen(false);
                  setDeleteText("");
                  setSelectedTool(null);
                }}
              >
                Cancel
              </Button>

              <Button
                danger
                type="primary"
                loading={submitting}
                disabled={deleteText !== selectedTool.ToolName}
                onClick={handleDelete}
              >
                Delete
              </Button>
            </div>
          </div>
        )}
      </Modal>
    </div>
  );
}

export default Resources;